import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class OpportunityIdValidatorService {

	private subject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

	addOpportunityId(opportunityId: string) {
		this.subject.next(opportunityId);
	}

	onChange(): Observable<string | null> {
		return this.subject.asObservable();
	}

	getCurrentValue(): string | null {
		return this.subject.getValue();
	}
}
